import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import ListingForm from '../../../components/forms/ListingForm';
import { useListingApi } from '../../../hooks/useListingApi';
import { useNavigate } from 'react-router-dom';
import { ListingDTO } from '../../../services/apiClient';

const ListingCreate: React.FC = () => {
  const { create, isLoading } = useListingApi();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Listings', href: '/admin/listings' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: ListingDTO) => {
    try {
      await create(data);
      navigate(-1);
    } catch (error) {
      console.error('Error creating Listing:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/listings"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Manage.Listing.Edit'
    >
        <ListingForm
          initialValues={{} as ListingDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate(-1)}
        />
    </AdminLayout>
  );
};

export default ListingCreate;